module.exports = __webpack_public_path__ + "img/M_map_3.03caeccf.png";